import { cn } from "../lib/utils";

export function Pulse(): React.ReactElement {
	return (
		<div
			className={cn(
				"mx-xs",
				"h-3 w-3 rounded-full",
				"relative",
				"flex-shrink-0 flex-grow-0",
			)}
		>
			<div className="absolute top-0 left-0 h-full w-full animate-[pulse_2s_infinite_linear] rounded-full bg-surface-inverted opacity-0 delay-1000" />
			<div className="absolute top-0 left-0 h-full w-full animate-[pulse_2s_infinite_1s_linear] rounded-full bg-surface-inverted opacity-0" />
		</div>
	);
}
